// @flow

import React, { Component } from 'react';
import FormsyText from 'formsy-material-ui/lib/FormsyText';
import Formsy from 'formsy-react';
// import validations from 'formsy-react/lib/validationRules';

type Props = {
  type: string,
  name: string
};

Formsy.addValidationRule('isSiblingCoreNotEmpty', (values, value, siblingCore) => {
  if (value === '') {
    return (values[siblingCore] === '');
  }
  return true;
});

Formsy.addValidationRule('isValueAllowed', (values, value, allowedValues) => {
  if (value !== '') {
    return allowedValues.values.indexOf(parseInt(value, 10)) !== -1 || (value >= allowedValues.range.min && value <= allowedValues.range.max);
  }

  return true;
});


class Core extends Component {
  config: {
    name: string,
    label: string,
    hintText: string,
    allowedValues: {
      values: Array<number>,
      range: {
        min: number,
        max: number
      }
    },
    coreType: string,
    siblingType: string,
    siblingTypeLabel: string
  };

  constructor(props: Props) {
    super(props);

    let coreType = this.props.type;
    let name = this.props.name;
    let label = name.toUpperCase();

    let siblingType, min, max, values;
    if (coreType === 'tumor_positive') {
      siblingType = 'overall_gleason';
      min = 0;
      max = 100;
      values = [];
    } else {
      siblingType = 'tumor_positive';
      min = 6;
      max = 10;
      values = [0];
    }
    let siblingTypeLabel = siblingType.replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase());
    let hintText = `${values.length > 0 ? `${values} or ` : ``}${min}~${max}`;

    this.config = {
      name: name,
      label: label,
      hintText: hintText,
      allowedValues: {
        values: values,
        range: {
          min: min,
          max: max
        }
      },
      coreType: coreType,
      siblingType: siblingType,
      siblingTypeLabel: siblingTypeLabel
    }
  }

  handleChange = (event: Event) => {
    let value = event.currentTarget.value;
    if (value.match(/^0.+$/)) {
      value = '0';
    }
    this.props.onChange(this.config.name, this.config.coreType, value);
  }

  render() {
    return (
      <FormsyText
        name={`${this.config.coreType}[${this.config.name}]`}
        validations={{
            isInt: true,
            isSiblingCoreNotEmpty: `${this.config.siblingType}[${this.config.name}]`,
            isValueAllowed: this.config.allowedValues
          }
        }
        style={{ float: "left", width:"15%", margin: "10px 5%"}}
        validationErrors={{
          isInt: 'Only integers allowed in this field',
          isSiblingCoreNotEmpty: `This field must be filled if ${this.config.siblingTypeLabel} for ${this.config.label} is not empty`,
          isValueAllowed: 'Enter an allowed value'
        }
        }
        hintText={this.config.hintText}
        floatingLabelText={this.config.label}
        onChange={this.handleChange}
        value={this.props.value}
      />
    )
  }

}

export default Core;



/** WEBPACK FOOTER **
 ** ./src/Components/Core.js
 **/